import * as React from 'react';
import Body from "../global/Body";
import reducer from "../../store/request";
import withReducer from "../../store/withReducer";
import {memo} from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Check, CheckCircle} from "@mui/icons-material";


function Step6Paid() {
    return (
        <Body>
            <Box sx={{py: 14, textAlign: 'center'}}>
                <Box sx={{
                    width       : 120,
                    height      : 120,
                    bgcolor     : 'primary.main',
                    borderRadius: '50%',
                    display     : 'inline-block',
                }}>
                    <Check sx={{
                        fontSize     : 100,
                        verticalAlign: 'middle',
                        marginTop    : 1,
                        color        : 'white',
                    }}/>
                </Box>
                <Typography variant="h4" color="white" fontWeight="bold" mt={3}>
                    Su reserva ha sido creada con éxito.
                </Typography>
            </Box>
        </Body>
    );
}

export default withReducer('request', reducer)(memo(Step6Paid));